const getters = {
  race: (state) => {
    return state.race
  },
  types:(state) => {
     return state.types
  },
  runners: (state) => {
    return state.runners
  },
  isRaceLive: (state) => {
    return state.race.id >0 && state.isRaceLive
  }
}

export default getters



// WEBPACK FOOTER //
// ./src/store/modules/races/getters.js